<template>
  <loading
    :active="isLoadingModel"
    :can-cancel="true"
    
    color="#ffc107"
    :is-full-page="fullPage"
  ></loading>
 
  <div class="grid">
    <div class="col-12">
      <div class="card">
        <Toast />
        <Toolbar class="mb-4">
          <template v-slot:start>
            <div class="my-2">
              <Button
                label="New"
                icon="pi pi-plus"
                class="p-button-success mr-2"
                @click="openNew"
              />
              <!-- <Button
                label="Delete"
                icon="pi pi-trash"
                class="p-button-danger"
                @click="confirmDeleteSelected"
                :disabled="!selectedProducts || !selectedProducts.length"
              /> -->
              <!-- &nbsp;
              <Button
                icon="pi pi-sync"
                class="p-button-info mr-2"
                @click="get_list"
              /> -->
            </div>
          </template>

          <template v-slot:end>
            <!-- <FileUpload
              mode="basic"
              accept="application/pdf,image/jpeg,image/png"
              :maxFileSize="1000000"
              label="Import"
              chooseLabel="Import"
              class="mr-2 inline-block"
            /> -->
            <Button
              label="Export"
              icon="pi pi-upload"
              class="p-button-help"
              @click="exportCSV($event)"
            />
          </template>
        </Toolbar>

        <DataTable
          :loading="loading"
          ref="dt"
          :lazy="true"
          :totalRecords="totalRecords"
          :paginator="true"
          :value="Course"
          v-model:selection="selectedProducts"
          :dataKey="columns[0]"
          :rows="limit"
          :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25, totalRecords]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          style="font-size: 12px"
          :rowHover="true" showGridlines
        >
        <template #empty>
        <b style="text-align:center">No records found.</b>
      </template>
          <template #header>
            <div
              class="
                flex flex-column
                md:flex-row md:justify-content-between md:align-items-center
              "
            >
              <h5 class="m-0"><b>Course Master</b></h5>
                  <Button icon="pi pi-refresh" @click="get_list()" />
              <!-- <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="filters['global'].value" placeholder="Search..." />
                            </span> -->
            </div>
          </template>

          <!-- <Column v-for="(col,index) in columns" :field="col" :header="col.toUpperCase()" :key="index"></Column> 
           <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>  -->

          <Column header="Sr No" style="min-width: 5rem;text-align: center">
            <template #body="{ index}">
            <span v-if="page_no==1">{{ +index+ +1 }}</span>
              <span v-else>{{(+index+1)+limit*(page_no-1)}}</span>
            </template>
          </Column>

         
          <Column header="Course Name" style="min-width: 5rem" :field="columns[10]">
            <template #body="{ data }">
              {{ data.scheme_title }}
            </template>
          </Column>
       
          <Column header="From Date" :field="columns[3]">
              <template #body="{ data }">
                {{ data.fromdate }}
              </template>
            </Column>
          <Column header="To Date" :field="columns[4]">
            <template #body="{ data }">
              {{ data.todate }}
            </template>
          </Column>
          <Column header="Price" :field="columns[11]">
            <template #body="{ data }">
              {{ data.price }}
            </template>
          </Column>
                    
          <Column header="Edit" headerStyle="min-width:5rem;">
            <template #body="slotProps">
              <Button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success mr-2"
                @click="editProduct(slotProps.data)"
              />
              <Button
                icon="pi pi-trash"
                class="p-button-rounded p-button-warning mt-2"
                @click="confirmDeletescheme(slotProps.data)"
              />
            </template>
          </Column>
        </DataTable>

        <Dialog
          v-model:visible="productDialog"
          :style="{ width: '450px', width: '450px' }"
          header="Course Details"
          :modal="true"
          class="p-fluid"
        >
          <div class="grid">
            <div class="col-12 md:col-12">
              <div class="field">
                <!-- <img
            :src="'images/product/shoes.jpg'"
            :alt="product.image"
            width="150"
            class="mt-0 mx-auto mb-5 block shadow-2"
          /> -->
              </div>
              <div class="field">
                <label for="course">Course Name</label>
                <InputText
                  id="course"
                  v-model.trim="product.scheme_title"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !product.course }"
                />                
              </div>

              <!-- <div class="field">
                <label for="status">Select Status</label>

                <Dropdown
                  id="status"
                  v-model="selectstatus"
                  :options="dropdownItems2"
                  :value="dropdownItems2"
                  optionLabel="name"
                  placeholder="Select One"
                  :class="{ 'p-invalid': submitted && !selectstatus }"
                  required="true"
                ></Dropdown>
              </div> -->
           
              <div class="field">
                  <Calendar
                    style="width: 200%"
                    v-model="product.fromdate"
                    :showIcon="true"
                    dateFormat="d-MM-yy"
                    hourFormat="12"
                    :numberOfMonths="2"
                    placeholder="From Date"
                  />
                </div>
                <div class="field">
                  <Calendar
                    style="width: 200%"
                    v-model="product.todate"
                    :showIcon="true"
                    dateFormat="d-MM-yy"
                    hourFormat="12"
                    :numberOfMonths="2"
                    placeholder="To Date"
                  />
                </div>
                <div class="field">
                    <label for="course">Course Price</label>
                    <InputText
                      id="course"
                      v-model.trim="product.price"
                      required="true"
                      autofocus
                      :class="{ 'p-invalid': submitted && !product.price }"
                      type="number"
                    />
                  </div>
              



            </div>
            <div class="col-12 md:col-6">
              <Button
                v-if="product.scheme_id"
                label="UPDATE"
                icon="pi pi-check"
                class="p-button-success mr-1 mb-1"
                @click="editCourse"
               
              />
              <Button
                v-else
                label="ADD"
                icon="pi pi-check"
                class="p-button-success mr-1 mb-1"
                @click="AddCourse"
              />

            </div>
            <div class="col-12 md:col-6">
              <Button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-danger mr-1 mb-1"
                @click="productDialog = false;"
              />
            </div>
          </div>
        </Dialog>

        <Dialog
          v-model:visible="deleteschemeDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="product"
              >Are you sure you want to delete <b>{{ product.scheme_title }}</b
              >?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteschemeDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteVideo"
            />
          </template>
        </Dialog>

        <Dialog
          v-model:visible="deleteProductsDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="product"
              >Are you sure you want to delete the selected Scheme?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteProductsDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteSelectedProducts"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
//import FormNewsMaster from "@/components/FormNewsMaster";
//import * as Survey from "survey-vue";

// import axios from "axios";
import apis from "@/apis";
import axios from "axios";

export default {
  data() {
    return {
      page_no:1,
      Price:"",
      isLoading:false,
            isLoadingModel:false,
            loading: false,
            fullPage:true,
      file_attachment: "",
      dropdownItems: [
        { name: "Motivational", value: "Motivational" },
        { name: "Interview", value: "Interview" },
      ],
      dropdownItems2: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        // { name: "Deleted", value: "Deleted" }
      ],
      Course: null,
      productDialog: false,
      deleteschemeDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      selectstatus: null,
      selectstatus2: { name: "Motivational", value: "Motivational" },
      limit: 10,
      columns: [],
      head: [
        "Data Usages",
        "Network Connectivity",
        "Students",
        "Teachers",
        "Student Registration",
        "News Master",
        "Government Panel",
        "Feedback Master",
        "User Queries",
        "Schemes Master",
        "Notice Master",
        "Subject Master",
        "Teacher Schedule Master",
        "Teacher Schedule DE Master",
        "Query Types Master",
        "Sub Query Types Master",
        "Admin Users",
        "Application Roles",
        "Departments",
        "Cast Master",
        "Year Master",
        "District Master",
        "Student Attendance",
        "Student Document",
        "Teachers",
        "Radical ids",
        "Subject Topics",
        "Query Comments",
        "Student Submit Answers",
        "Mock Tests",
        "Mock Test Papers",
        "Mock Test Results",
        "Video",
        "Syllabus",
        "Course"
      ],
      pageno: 1,
      submitted: false,
      totalRecords: 0,
      id: "",
      statuses: [
        { label: "INSTOCK", value: "instock" },
        { label: "LOWSTOCK", value: "lowstock" },
        { label: "OUTOFSTOCK", value: "outofstock" },
      ],
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.initFilters();
  },
  async mounted() {
    // this.productService.getProducts().then(data => this.products = data);
    this.id = this.$route.params.id;

    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
    //alert(this.id);
  },
  watch: {
    async $route() {
      this.Course = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  methods: {
    handleFileUpload() {
      this.file_attachment = this.$refs.file_attachment.files[0];

      //alert(this.$refs.file_attachment.files[0].name);
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      // console.log(event);
      await this.get_count();
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var data = {
        count: true,
      };
      this.loading = true;
      var promise = apis.Courselist(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.totalRecords = response.data.data;
        //alert(this.totalRecords);
      });

      console.log(data);
    },
    get_list: function () {
      var data = {
        Limit: this.limit,
        page_no: this.page_no,
        count: false,
      };
      this.loading = true;
      var promise = apis.Courselist(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.Course = response.data.data;
        console.log(this.Course[0]);
        if (this.columns.length == 0) {
          if (this.Course.length > 0) {
            this.columns = Object.keys(this.Course[0]);
          }
        }
      });
    },
    formatCurrency(value) {
      if (value)
        return value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
      return;
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
  async AddCourse() {
    this.submitted = true;
    if(!this.product.scheme_title)
    {
    this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Course name",
            life: 3000,
          });
          return false;
    }
    // if (this.product.mjnB_ID) {
      var to = new Date(this.product.fromdate);
      var date =
        to.toLocaleDateString("en-US", { year: "numeric" }) +
        "-" +
        to.toLocaleDateString("en-US", { month: "2-digit" }) +
        "-" +
        to.toLocaleDateString("en-US", { day: "2-digit" });
        " " +
        to.toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit', second: '2-digit' });

        var to = new Date(this.product.todate);
        var date1 =
        to.toLocaleDateString("en-US", { year: "numeric" }) +
        "-" +
        to.toLocaleDateString("en-US", { month: "2-digit" }) +
        "-" +
        to.toLocaleDateString("en-US", { day: "2-digit" });
        " " +
        to.toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit', second: '2-digit' });

      
        var data = {
          scheme_desc: this.product.scheme_title,
          is_active: 1,
          from_date: date,
          till_date: date1,  
          user_id: localStorage.getItem("id"),
          created_by: localStorage.getItem("id"),
          updated_by: localStorage.getItem("id"),
          scheme_title: this.product.scheme_title,
          Price : this.product.price
          
        };
        this.isLoadingModel = true;
        var promise = apis.addcoursemaster(data);
        promise
          .then((responseapi) => {
            this.$swal(responseapi.data.message);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;

            this.$swal.fire(error.response.data);
             this.get_list();
             this.get_count();

          });
          
       this.selectstatus={name:"",value:""}
      
     },
      //add-----------------------------------------------------------------------------------------------------------------
    editCourse() {
    this.submitted = true;
    if(!this.product.scheme_title)
    {
    this.$toast.add({
            severity: "error",
            summary: "error",
            detail: "Please Enter Course name",
            life: 3000,
          });
          return false;
    }
          var to = new Date(this.product.fromdate);
          var date =
        to.toLocaleDateString("en-US", { year: "numeric" }) +
        "-" +
        to.toLocaleDateString("en-US", { month: "2-digit" }) +
        "-" +
        to.toLocaleDateString("en-US", { day: "2-digit" });
        " " +
        to.toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit', second: '2-digit' });

        var to = new Date(this.product.todate);
          var date1 =
        to.toLocaleDateString("en-US", { year: "numeric" }) +
        "-" +
        to.toLocaleDateString("en-US", { month: "2-digit" }) +
        "-" +
        to.toLocaleDateString("en-US", { day: "2-digit" });
        " " +
        to.toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit', second: '2-digit' });
       
        var data1 = 
        {
          scheme_id: this.product.scheme_id,
          scheme_desc: this.product.scheme_title,
          is_active: 1,
          from_date: date,
          till_date: date1,  
          user_id: localStorage.getItem("id"),
          // updated_at: this.product.updated_at,    
          updated_by: localStorage.getItem("id"),
          scheme_title: this.product.scheme_title,
          Price: this.product.price,
        };
        this.isLoadingModel = true;
        var promises = apis.editcoursemaster(data1);
        promises
          .then((responseapi) => {
            
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal(responseapi.data.message);
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;

            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
    

       this.selectstatus={name:"",value:""}
       
    },
    saveProduct() {
      this.submitted = true;
      if (this.product.name.trim()) {
        if (this.product.id) {
          this.product.inventoryStatus = this.product.inventoryStatus.value
            ? this.product.inventoryStatus.value
            : this.product.inventoryStatus;
          this.product[this.findIndexById(this.product.id)] = this.product;
          this.$toast.add({
            severity: "success",
            summary: "Successful",
            detail: "Product Updated",
            life: 3000,
          });
        } else {
          this.product.id = this.createId();
          this.product.code = this.createId();
          this.product.image = "product-placeholder.svg";
          this.product.inventoryStatus = this.product.inventoryStatus
            ? this.product.inventoryStatus.value
            : "INSTOCK";
          this.product.push(this.product);
          this.$toast.add({
            severity: "success",
            summary: "Successful",
            detail: "Product Created",
            life: 3000,
          });
        }
        this.productDialog = false;
        this.product = {};
      }
    },
    editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      this.productDialog = true;

      //this.selectstatus={name:this.product.Price,value:this.product.Price}


      // this.selectstatus.value = this.product.status;
      // this.selectstatus.name = this.product.status;
   
      // this.selectstatus.value = this.product.type;
      // this.selectstatus.name = this.product.type;

      // this.selectstatus2.value = this.product.status;
      // this.selectstatus2.name = this.product.status;

      // this.file_attachment = this.product.image;
    },
    confirmDeletescheme(product) {
      this.product = product;
      if (this.product.is_active == 1) {
        this.deleteschemeDialog = true;
      }else{
        this.$swal("Already Deleted");
      }
      
     
    },
    deleteProduct() {
      this.product = this.product.filter((val) => val.id !== this.product.id);
      this.deleteschemeDialog = false;
      this.product = {};
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Scheme Deleted",
        life: 3000,
      });
    },

    deleteVideo() {
     
        var data = {
          scheme_id: this.product.scheme_id,
        };
        this.isLoadingModel = true;
        var promise = apis.deletecoursemaster(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.status == 200) {
            
            // this.hideDialog1();
            this.deleteschemeDialog = false;
            this.$swal(responseapi.data);
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Scheme");
          }       
        });   
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.product.length; i++) {
        if (this.product[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    createId() {
      let id = "";
      var chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteProductsDialog = true;
    },
    deleteSelectedProducts() {
      this.product = this.product.filter(
        (val) => !this.selectedProducts.includes(val)
      );
      this.deleteProductsDialog = false;
      this.selectedProducts = null;
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Products Deleted",
        life: 3000,
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
@import "../assets/demo/badges.scss";
</style>
